import { render, staticRenderFns } from "./PrintSubBearCoupon.vue?vue&type=template&id=4a54324a&scoped=true"
import script from "./PrintSubBearCoupon.vue?vue&type=script&lang=js"
export * from "./PrintSubBearCoupon.vue?vue&type=script&lang=js"
import style0 from "./PrintSubBearCoupon.vue?vue&type=style&index=0&id=4a54324a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54324a",
  null
  
)

export default component.exports